<template>
  <div class="basicInfoDetail">
    <van-form
      label-width="120px"
      :show-error="false"
      :scroll-to-error="false"
      @submit="onSubmit"
    >
      <van-field
        v-model="form.CustomerNumber"
        :label="$t.basicInfo.customerNumber"
        label-class="number-label"
        readonly
        v-if="form.CustomerNumber"
      >
        <template #button>
          <van-button
            size="small"
            type="info"
            @click="onCopy(form.CustomerNumber)"
            native-type="button"
            >{{ $t.meta.copy }}</van-button
          >
        </template>
      </van-field>

      <div class="customerType-radio">
        <div class="radio-label">{{ $t.meta.customerTitle }}</div>
        <van-radio-group
          v-model="form.CustomerType"
          direction="horizontal"
          :disabled="isView ? true : false"
        >
          <van-radio name="1">{{ $t.meta.enterprise }}</van-radio>
          <van-radio name="2">{{ $t.meta.personal }}</van-radio>
        </van-radio-group>
      </div>

      <van-field
        clickable
        readonly
        :value="selectedCountry.text"
        :label="$t.meta.country"
        :placeholder="isView ? '' : $t.meta.select"
        :disabled="isView ? true : false"
        @click="onShowEmit('showBasicInfoDetailCountry')"
        required
        :rules="formRule"
      />

      <van-field
        clickable
        readonly
        :value="selectedCity.text"
        :label="$t.meta.city"
        :placeholder="isView ? '' : $t.meta.select"
        :disabled="isView ? true : false"
        @click="onShowEmit('showBasicInfoDetailCity')"
        required
        :rules="formRule"
      />

      <van-field
        v-model="form.CompanyName"
        :label="$t.basicInfo.companyName"
        :placeholder="isView ? '' : $t.meta.input"
        :disabled="isView ? true : false"
        required
        :rules="formRule"
        type="textarea"
        rows="3"
      />

      <van-field
        v-model="form.CompanyNameEn"
        :label="$t.basicInfo.companyNameEn"
        :placeholder="isView ? '' : $t.meta.input"
        :disabled="isView ? true : false"
        type="textarea"
        rows="3"
      />

      <van-field
        v-model="form.CompanyNameSn"
        :label="$t.basicInfo.companyNameSn"
        :placeholder="isView ? '' : $t.meta.input"
        :disabled="isView ? true : false"
        type="textarea"
        rows="3"
      />

      <van-field
        v-model="form.LegalPerson"
        :label="$t.basicInfo.legalPerson"
        :placeholder="isView ? '' : $t.meta.input"
        :disabled="isView ? true : false"
      />

      <van-field
        v-model="form.TelePhone"
        :label="$t.basicInfo.telePhone"
        :placeholder="isView ? '' : $t.meta.input"
        :disabled="isView ? true : false"
      />

      <van-field
        v-model="form.Email"
        :label="$t.basicInfo.email"
        :placeholder="isView ? '' : $t.meta.input"
        :disabled="isView ? true : false"
      />

      <van-field
        v-model="form.PersonalID"
        :label="$t.basicInfo.personalID"
        :placeholder="isView ? '' : $t.meta.input"
        :disabled="isView ? true : false"
      />

      <van-field
        v-model="form.PersonalPassport"
        :label="$t.basicInfo.personalPassport"
        :placeholder="isView ? '' : $t.meta.input"
        :disabled="isView ? true : false"
      />

      <van-field
        v-model="form.CustomerPhone"
        :label="$t.basicInfo.customerPhone"
        :placeholder="isView ? '' : $t.meta.input"
        :disabled="isView ? true : false"
      />

      <van-field :label="$t.basicInfo.businessLicence" :disabled="isView ? true : false">
        <template #input>
          <van-uploader
            v-model="certificate"
            :max-count="1"
            :after-read="afterRead1"
            :deletable="!isView ? true : false"
          />
        </template>
      </van-field>

      <van-field
        v-model="selectedRefer.text"
        :label="$t.basicInfo.refer"
        @click="pickerShow('showReferPicker')"
        :placeholder="isView ? '' : $t.meta.select"
        :disabled="isView ? true : false"
        clickable
        readonly
        required
        :rules="formRule"
      />

      <van-field
        v-model="form.Password"
        :label="$t.basicInfo.password"
        :placeholder="isView ? '' : $t.meta.input"
        :type="showPassword ? 'text' : 'password'"
        :disabled="isView ? true : false"
      >
        <template #button v-if="!isView">
          <van-icon
            name="eye-o"
            v-if="showPassword"
            @click="showPassword = !showPassword"
          />
          <van-icon name="closed-eye" v-else @click="showPassword = !showPassword" />
        </template>
      </van-field>

      <van-field
        v-model="form.Address"
        :label="$t.basicInfo.companyAddress"
        :placeholder="isView ? '' : $t.meta.input"
        type="textarea"
        rows="5"
        :disabled="isView ? true : false"
      />

      <van-field
        v-model="form.RelatedCompanyCode"
        :label="$t.basicInfo.companyCode"
        :placeholder="isView ? '' : $t.meta.input"
        :disabled="isView ? true : false"
      />

      <div style="margin: 16px" v-if="!isView">
        <van-button round block type="info" native-type="submit">{{
          $t.meta.save
        }}</van-button>
      </div>
    </van-form>

    <van-popup v-model="showReferPicker" round position="bottom">
      <van-picker
        :title="$t.basicInfo.refer"
        show-toolbar
        :columns="roleList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="referConfirm"
        @cancel="showReferPicker = false"
      />
    </van-popup>

    <option-list
      event="showBasicInfoDetailCountry"
      :options="countryList"
      @onSelect="onSelectCountry"
    ></option-list>

    <option-list
      event="showBasicInfoDetailCity"
      :options="cityList"
      @onSelect="onSelectCity"
    ></option-list>
  </div>
</template>
<script>
import Vue from "vue";
import OptionList from "@components/optionList/OptionList.vue";
import {
  Form,
  Field,
  Button,
  Icon,
  Image,
  Uploader,
  Picker,
  Popup,
  Radio,
  RadioGroup,
} from "vant";

Vue.use(Form)
  .use(Field)
  .use(Button)
  .use(Icon)
  .use(Image)
  .use(Uploader)
  .use(Picker)
  .use(Popup)
  .use(Radio)
  .use(RadioGroup);

export default {
  name: "basicInfoDetail",
  components: {
    OptionList,
  },
  data() {
    return {
      isView: false,
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      customerId: "",
      form: {
        CustomerType: "1",
        CompanyName: "",
        CompanyNameEn: "",
        CompanyNameSn: "",
        LegalPerson: "",
        TelePhone: "",
        Email: "",
        Address: "",
        ReferByUserId: "",
        Certificate: "",
        PersonalPassport: "",
        PersonalID: "",
        CustomerPhone: "",
        Password: "",
        CountryId: null,
        CityId: null,
        RelatedCompanyCode: "",
        ContactList: [],
      },
      formRule: [
        {
          required: true,
          message: this.$t.meta.require,
        },
      ],
      certificate: [],
      countryList: [],
      cityList: [],
      roleList: [],
      selectedCountry: { text: "", value: null },
      selectedCity: { text: "", value: null },
      selectedRefer: { text: "", value: null },
      showReferPicker: false,
      showPassword: false,
    };
  },
  created() {
    const { CustomerId, IsView } = this.$route.query;
    this.isView = IsView;
    if (CustomerId) {
      this.customerId = CustomerId;
      this.getOptions().then((success) => {
        if (success) {
          this.getCustomerDetail();
        }
      });
    } else {
      this.getOptions();
    }
  },
  methods: {
    referConfirm(e) {
      this.selectedRefer.text = e.text;
      this.selectedRefer.value = e.value;
      this.showReferPicker = false;
    },
    pickerShow(pickerName) {
      if (this.isView) {
        return;
      }
      this[pickerName] = true;
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [images],
        startPosition: 0,
      });
    },
    onCopy(text) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.clickCopy, {
        text: text,
        alertText: this.$t.meta.copySuccess,
      });
    },
    onSelectCountry(item) {
      this.selectedCountry.text = item.text;
      this.selectedCountry.value = item.value;
    },
    onSelectCity(item) {
      this.selectedCity.text = item.text;
      this.selectedCity.value = item.value;
    },
    onShowEmit(emit) {
      if (this.isView) {
        return;
      }
      this.$bus.$emit(emit, true);
    },
    onSubmit() {
      this.$commonMethod.showLoading();
      var param = this.form;
      param.CountryId = this.selectedCountry.value;
      param.CityId = this.selectedCity.value;
      param.ReferByUserId = this.selectedRefer.value;
      param.CompanyId = this.CompanyId;
      param.UserId = this.UserId;
      var request = null;
      if (this.customerId) {
        param.CustomerId = this.customerId;
        request = this.$api.customerManagement.editCustomerInfo(param);
      } else {
        request = this.$api.customerManagement.addCustomerInfo(param);
      }
      request
        .then(() => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.operateSuccess,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    getCustomerDetail() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {
          CustomerId: this.customerId,
        };
        this.$api.customerManagement
          .getCustomerDetail(param)
          .then((res) => {
            this.form = res.data[0] || [];
            if (this.form.Certificate) {
              this.certificate.push({
                url: this.imgUrlFilter(this.form.Certificate),
              });
            }
            var country = this.countryList.find((c) => c.value == this.form.CountryId);
            if (country) {
              this.selectedCountry.text = country.text;
              this.selectedCountry.value = country.value;
            }
            var city = this.cityList.find((c) => c.value == this.form.CityId);
            if (city) {
              this.selectedCity.text = city.text;
              this.selectedCity.value = city.value;
            }
            var refer = this.roleList.find((c) => c.value == this.form.ReferByUserId);
            if (refer) {
              this.selectedRefer.text = refer.text;
              this.selectedRefer.value = refer.value;
            }
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
    getOptions() {
      return new Promise((resolve) => {
        Promise.all([
          this.getCountryList(),
          this.getCityList(),
          this.getUserListByCondition(),
        ]).then((success) => {
          if (success) resolve(true);
        });
      });
    },
    getCountryList() {
      return new Promise((resolve) => {
        this.$api.customerManagement
          .getCountryList()
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.CountryName + "," + item.CountryName_en,
                value: item.CountryId,
              };
              result.push(data);
            });
            this.countryList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getCityList() {
      return new Promise((resolve) => {
        this.$api.logisticsManagement
          .getCountryList({
            type: 1,
          })
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.City_cn + "," + item.City_en,
                value: item.Id,
              };
              result.push(data);
            });
            this.cityList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getUserListByCondition() {
      return new Promise((resolve) => {
        this.$api.systemManagement
          .getUserListByCondition({
            CompanyId: this.CompanyId,
            IsUse: 1,
          })
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.UserName,
                value: item.UserId,
              };
              result.push(data);
            });
            this.roleList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    afterRead1(file) {
      this.$commonMethod.showLoading();
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          this.form.Certificate = res.data;
          this.$commonMethod.hideLoading();
        })
        .catch(() => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.basicInfoDetail {
  ::v-deep .number-label {
    line-height: 33px;
  }
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  ::v-deep .van-radio__icon--disabled.van-radio__icon--checked {
    i {
      color: #1890ff;
      font-weight: bold;
    }
  }
  ::v-deep .van-radio__label--disabled.van-radio__label {
    color: #999 !important;
    -webkit-text-fill-color: #999 !important;
  }
  ::v-deep .van-checkbox__icon--disabled.van-checkbox__icon--checked {
    i {
      color: #1890ff;
      font-weight: bold;
    }
  }
  ::v-deep .van-checkbox__label--disabled.van-checkbox__label {
    color: #999 !important;
    -webkit-text-fill-color: #999 !important;
  }
  ::v-deep .van-field--disabled {
    .van-field__label,
    .van-field__control {
      color: #999 !important;
      -webkit-text-fill-color: #999 !important;
    }
  }
  .customerType-radio {
    padding: 20px;
    border-bottom: 1px solid #ebedf0;
    .radio-label {
      color: #646566;
      margin-bottom: 20px;
      font-size: 14px;
    }
    .van-radio {
      margin-right: 20px;
      font-size: 14px;
    }
  }
}
</style>
